import { render, staticRenderFns } from "./folder_assignment_selector.vue?vue&type=template&id=4b63790a&"
import script from "./folder_assignment_selector.vue?vue&type=script&lang=js&"
export * from "./folder_assignment_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports